export default "__VITE_ASSET__CKShPEQ0__"